export default  {
  resetState: ({ commit }) => commit('resetState'),
  addSelected ({state, commit, dispatch }, item){
    commit('addSelected', item )
  },
  populate ({state, commit, dispatch }, options){
      commit('clearTags')
      options.query = 'tagsFilter'
      dispatch('graph', {type: 'graph.array', options: options, next: function (list, count) {
        if (options.next) options.next(list)
        commit('setList', list )
      }}, {root: true} )
  },
  updateCount ({state, commit, dispatch }, options){
      options.query = 'tagsCounter'
      commit('resetCounter')
      dispatch('graph', {type: 'graph.array', options: options, next: function (list, count) {
         if (!count) return false
          
          list.forEach(function(item){
           commit('setCount', item)
          })
          if (options.next) return options.next(list)
          state.types = Object.assign({}, state.types)
      }}, {root: true} )
  },
  resultChart ({state, commit, dispatch }, options){
      options.query = options.query || 'getChartinfo'
      dispatch('graph', {type: 'graph.array', options: options, next: function (list, count) {
        if (options.next) options.next(list, count)
      }}, {root: true} )
  }
}